import func from '../assets/js/common'
import global from '../assets/js/global.json'

// 引用axios
var axios = require('axios')
var qs = require('qs')
// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
// 接口处理函数
function apiAxios (method, url, params, callback) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: window.vm.$api_host,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: true
  })
    .then(function (res) {
      if (res.data.code === -1) {
        sessionStorage.setItem('redirect', window.router.currentRoute.fullPath)
        return
      } else if (res.data.code === -100) {
        window.router.replace({ name: 'Jump', params: { status: 'error', message: res.data.message } })
        return
      }
      if (callback) {
        callback(res.data)
      }
    })
    .catch(function (err) {
      if (err.response) {
        window.vm.$alert('请求错误')
      }
    })
}

function apiForIE (method, url, params, callback) {
  if (params) {
    params = filterNull(params)
  }
  var link = global.globalPath + '/api' + url
  var xhr = new XMLHttpRequest()
  xhr.open(method, link, false)
  xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded')
  xhr.withCredentials = false
  xhr.send(qs.stringify(params))
  let result = JSON.parse(xhr.responseText)
  if (callback) {
    callback(result)
  }
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, callback) {
    if (process.browser) {
      return apiAxios('GET', url, params, callback)
    } else {
      return false
    }
  },
  post: function (url, params, callback) {
    if (process.browser) {
      if (func.getCurrentBrowser() !== 'IE9') {
        return apiAxios('POST', url, params, callback)
      } else {
        return apiForIE('POST', url, params, callback)
      }
    } else {
      return false
    }
  },
  put: function (url, params, callback) {
    if (process.browser) {
      return apiAxios('PUT', url, params, callback)
    } else {
      return false
    }
  },
  delete: function (url, params, callback) {
    if (process.browser) {
      return apiAxios('DELETE', url, params, callback)
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js